import { useEffect, useState } from "react";
import sanitizeInput from "../utils/sanitizeInput.js";
const useChatMessagesState = (props)=>{
    const { submitChatMessagesPayload } = props;
    const [chatMessages, setChatMessages] = useState([]);
    const [santizedSubmitChatMessagesPayload, setSanitizedSubmitChatMessagesPayload] = useState(submitChatMessagesPayload);
    useEffect(()=>{
        if (!submitChatMessagesPayload) return;
        const { isPortal = false } = submitChatMessagesPayload;
        let updatedPayload = {
            ...submitChatMessagesPayload
        };
        if (updatedPayload.pushPrompt && !isPortal) updatedPayload = {
            ...updatedPayload,
            pushPrompt: sanitizeInput(updatedPayload.pushPrompt)
        };
        setSanitizedSubmitChatMessagesPayload(updatedPayload);
    }, [
        submitChatMessagesPayload
    ]);
    return {
        chatMessages,
        setChatMessages,
        santizedSubmitChatMessagesPayload,
        setSanitizedSubmitChatMessagesPayload
    };
};
export { useChatMessagesState };
